<template>
  <div class="flex-col justify-center items-start gap-8 flex w-full">
    <div class="tw-divider-new"></div>
    <div class="section_break tw-text-lg font-semibold" name="text" v-html="$sanitize($tr(field.datahash, 'label'))"></div>
  </div>
</template>
<script>
import mixin from './_mixin_display'
export default { mixins: [mixin] }
</script>